<div class="white-box main-black mt-4 p-4 border-radius">
	<!-- date filter -->
	<div class="row col-xl-12 mb-4">
		<div class="col-xl-4 col-md-4">
			<div class="input-group">
				<div class="input-group-prepend">
					<span class="input-group-text">{{'g.start_date' | translate}}</span>
				</div>
				<input
					type="text"
					class="form-control"
					placeholder="mm/dd/yyyy"
					name="dp1"
					(ngModelChange)="changeDate('fromDate', $event)"
					[(ngModel)]="fromDate"
					bsDatepicker
					#d1="bsDatepicker"
					[bsConfig]="{containerClass: 'theme-dark-blue'}"
					[maxDate]="toDate"
					[minDate]="minDate"
				>
				<div class="input-group-append pointer" (click)="d1.toggle()">
					<span class="input-group-text"><i class="fa fa-calendar"></i></span>
				</div>
			</div>
		</div>

		<div class="col-xl-4 col-md-4">
			<div class="input-group">
				<div class="input-group-prepend">
					<span class="input-group-text">{{'g.end_date' | translate}}</span>
				</div>
				<input
					type="text"
					class="form-control"
					placeholder="mm/dd/yyyy"
					name="dp2"
					(ngModelChange)="changeDate('toDate', $event)"
					[(ngModel)]="toDate"
					bsDatepicker
					#d2="bsDatepicker"
					[bsConfig]="{containerClass: 'theme-dark-blue'}"
					[minDate]="fromDate"
					[maxDate]="maxDate"
				>
				<div class="input-group-append pointer" (click)="d2.toggle()">
					<span class="input-group-text"><i class="fa fa-calendar"></i></span>
				</div>
			</div>
		</div>

		<div class="row col-xl-12 mt-4">
			<div class="col-xl-4 col-md-4">
				<label class="mr-2">{{'iotemeter_site_energy_report.select_meter_type' | translate}}</label>
				<ng-select
					[searchable]="false"
					[items]="devicesList"
					bindLabel="label"
					bindValue="value"
					placeholder="{{'g.select_device_type' | translate}}"
					name="device_type"
					[(ngModel)]="selectedDeviceType"
					[clearable]="false"
					(ngModelChange)="getIotemeterDailyEnergyReports()"
				></ng-select>
			</div>
		</div>
	</div>


	<div class="mt-5 mb-3" *ngIf="tableData.length">
		<h5>{{ 'iotemeter_site_energy_report.daily_consumption_report' | translate }}</h5>
	</div>

	<!-- table -->
	<div class="col-12">
		<sct-custom-table
			[columnsConfig]="columnConfig"
			[data]="tableData"
			[config]="tableConfig"
		></sct-custom-table>
	</div>

	<!-- table -->
	<div class="col-12" *ngIf="chartsData.consumed_energy.length">
		<div class="row">
			<div class="my-3 col-12 d-flex justify-content-between align-items-center">
				<h5 class="m-0">{{ 'iotemeter_site_energy_report.daily_energy_usage' | translate }}</h5>
				<button class="fa fa-upload btn" title="{{'g.export_to_csv' | translate}}" (click)="exportDataToCsv()"></button>
			</div>

			<sct-charts
				id="daily_energy_usage"
				[title]="consumedChartConfig.title"
				[data]="chartsData.consumed_energy"
				[columnNames]="chartColumns.consumed_energy"
				[options]="consumedChartConfig"
				[type]="'ColumnChart'"
				[height]="500"
				[haveZoom]="true"
			></sct-charts>
		</div>

		<div class="row">
			<div class="my-3">
				<h5>{{ 'iotemeter_site_energy_report.daily_power_demand' | translate }}</h5>
			</div>

			<sct-charts
				id="daily_power_demand"
				[title]="demandChartConfig.title"
				[data]="chartsData.demand_energy"
				[columnNames]="chartColumns.demand_energy"
				[options]="demandChartConfig"
				[type]="'LineChart'"
				[height]="500"
				[haveZoom]="true"
			></sct-charts>
		</div>
	</div>
</div>

<ng-template #noData class="mt-4">
	<div class="alert alert-info">{{'g.no_data_to_show' | translate}}</div>
</ng-template>
